import env from 'environment';

import DefaultContainer from '@/containers/DefaultContainer'

const testRoutes = [
  {
    path: '/test',
    // redirect: '/public/home',
    name: 'TestPages',
    component: DefaultContainer,
    props: {
      example: false,
      // brandTo: '/protected/home',
    },
    children: [
      {
        path: 'charts/bar',
        name: 'BarCharts',
        component: () => import('app/test/charts/Bar')
      },
      {
        path: 'charts/web',
        name: 'WebCharts',
        component: () => import('app/test/charts/Web')
      },
    ]
  }
];

export const appRoutes = [
  ...(env.testPages ? testRoutes : []),
  {
    path: '/public',
    redirect: '/public/home',
    name: 'PublicPages',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: 'forbidden',
        name: 'Page403',
        component: () => import('vue-core/public/Page403')
      },
      {
        path: 'not-found',
        name: 'Page404',
        component: () => import('vue-core/public/Page404')
      },
      {
        path: 'server-error',
        name: 'Page500',
        component: () => import('vue-core/public/Page500')
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('vue-core/public/Login')
      },
      {
        path: 'invitations/:context/:id/:email',
        name: 'SignUp',
        component: () => import('vue-core/public/Signup')
      },
      {
        path: 'signed-up',
        name: 'SignedUp',
        component: () => import('vue-core/public/SignedUp')
      },
      {
        path: 'home',
        name: 'Home',
        component: () => import('app/public/Home')
      },
    ]
  },
  {
    path: '/protected',
    redirect: '/protected/home',
    name: 'ProtectedPages',
    component: DefaultContainer,
    props: {
      example: false,
      brandTo: '/protected/home',
    },
    children: [
      {
        path: 'home',
        name: 'ProtectedHome',
        component: () => import('app/protected/HomePage')
      },
      // =======================================
      {
        path: 'system/info',
        name: 'SystemInfo',
        component: () => import('app/protected/SystemInfoPage')
      },
      {
        path: 'system/sessions',
        name: 'UserSessions',
        component: () => import('app/protected/UserSessionsPage')
      },
      // =======================================
      {
        path: 'analyses',
        name: 'Analyses',
        component: () => import('app/protected/AnalysesPage')
      },
      {
        path: 'analyses/:id',
        name: 'Analysis',
        component: () => import('app/protected/AnalysisPage')
      },
      {
        path: 'analyses/:analysisId/cr',
        name: 'CrAnalyses',
        component: () => import('app/protected/CrAnalysesPage')
      },
      {
        path: 'analyses/:analysisId/cr/:id/:originalId',
        name: 'CrAnalysisClone',
        component: () => import('app/protected/CrAnalysisPage'),
        props: { forceEdit: true }
      },
      {
        path: 'analyses/:analysisId/cr/:id',
        name: 'CrAnalysis',
        component: () => import('app/protected/CrAnalysisPage')
      },
      {
        path: 'analyses/:analysisId/crif',
        name: 'CrifAnalyses',
        component: () => import('app/protected/CrifAnalysesPage')
      },
      {
        path: 'analyses/:analysisId/crif/:id/:originalId',
        name: 'CrifAnalysisClone',
        component: () => import('app/protected/CrifAnalysisPage'),
        props: { forceEdit: true }
      },
      {
        path: 'analyses/:analysisId/crif/:id',
        name: 'CrifAnalysis',
        component: () => import('app/protected/CrifAnalysisPage')
      },
      {
        path: 'analyses/:analysisId/xbrl',
        name: 'XbrlAnalyses',
        component: () => import('app/protected/XbrlAnalysesPage')
      },
      {
        path: 'analyses/:analysisId/xbrl/:id/:originalId',
        name: 'XbrlAnalysisClone',
        component: () => import('app/protected/XbrlAnalysisPage'),
        props: { forceEdit: true }
      },
      {
        path: 'analyses/:analysisId/xbrl/:id',
        name: 'XbrlAnalysis',
        component: () => import('app/protected/XbrlAnalysisPage')
      },
      {
        path: 'analysis-types',
        name: 'AnalysisTypes',
        component: () => import('app/protected/AnalysisTypesPage')
      },
      {
        path: 'analysis-type/:id',
        name: 'AnalysisType',
        component: () => import('app/protected/AnalysisTypePage')
      },
      {
        path: 'reports',
        name: 'Reports',
        component: () => import('app/protected/ReportsPage')
      },
      {
        path: 'reports/:id',
        name: 'Report',
        component: () => import('app/protected/ReportPage')
      },
      {
        path: 'roles',
        name: 'Roles',
        component: () => import('app/protected/RolesPage')
      },
      {
        path: 'roles/:id',
        name: 'Role',
        component: () => import('app/protected/RolePage')
      },
      {
        path: 'sign-requests/:id',
        name: 'SignRequest',
        component: () => import('app/protected/SignRequestPage')
      },
      {
        path: 'tags',
        name: 'Tags',
        component: () => import('app/protected/TagsPage')
      },
      {
        path: 'tags/:id',
        name: 'Tag',
        component: () => import('app/protected/TagPage')
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('app/protected/UsersPage')
      },
      {
        path: 'users/:id',
        name: 'User',
        component: () => import('app/protected/UserPage')
      },
      {
        path: 'workgroups',
        name: 'Workgroups',
        component: () => import('app/protected/WorkgroupsPage')
      },
      {
        path: 'workgroups/:id',
        name: 'Workgroup',
        component: () => import('app/protected/WorkgroupPage')
      },
      // =======================================
      {
        path: 'logout',
        name: 'Logout',
        component: () => import('vue-core/protected/Logout')
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('vue-core/protected/ChangePassword')
      },
      {
        path: 'forbidden',
        name: 'ProtectedPage403',
        component: () => import('vue-core/public/Page403')
      },
      {
        path: 'not-found',
        name: 'ProtectedPage404',
        component: () => import('vue-core/public/Page404')
      },
      {
        path: 'server-error',
        name: 'ProtectedPage500',
        component: () => import('vue-core/public/Page500')
      },
    ],
    meta: {
      requiresAuth: true
    }
  }
];
